import { useMutation, useQueryClient } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const usePayOverdueBalanceMutation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: paymentRepo.postOverdueBalancePayment,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE] });
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.BILLING_INFO] });
    },
  });

  return useMutationMemoized(mutation);
};

export type PayOverdueBalanceMutation = ReturnType<typeof usePayOverdueBalanceMutation>;
